export const seniorWebDirectorResume = `
【職務概要】
Webディレクターとして15年以上の経験を持ち、コーポレートサイトからBtoC/BtoBサービス、メディア運営、ECサイト構築まで幅広いジャンルのWebプロジェクトを手がけてきました。特に、UI/UXデザイン設計、プロジェクトマネジメント、データ分析に基づくサイト改善に強みを持っています。

企画・要件定義フェーズから制作・運用まで一貫したディレクションを担当し、クライアントの事業戦略を理解した上で最適なデジタルソリューションを提案・実現することで、KPI達成に寄与してきました。デザイン思考とテクノロジーを融合させたアプローチにより、単なるWebサイト構築だけでなく、ユーザー体験を軸にしたデジタルトランスフォーメーション推進に貢献しています。

近年は後進の育成にも力を入れており、チームマネジメントやナレッジ共有の仕組み構築を通じて、組織全体のスキル向上と品質標準化に取り組んでいます。最新のデジタルマーケティング手法やテクノロジートレンドを積極的に取り入れ、常に変化するデジタル環境に対応した提案力を維持しています。

【職務経歴】
・株式会社Algomaticデジタルマーケティング（2018年4月〜現在）
  ○ 会社概要：デジタルマーケティングエージェンシー、従業員120名、大手企業のデジタル戦略立案から実行支援まで提供
  ○ 職務内容：Webディレクション部門 マネージャー
    - 10名のディレクターチームをマネジメント、年間30〜40件のプロジェクトを統括
    - 大規模コーポレートサイトリニューアル、ECサイト構築、マーケティングサイト制作のディレクション
    - クライアントの事業戦略に基づいた中長期デジタル戦略の立案と実行計画策定
    - アクセス解析データを活用したサイト改善施策の立案と効果検証
    - ディレクター育成カリキュラムの策定と実施、社内ナレッジ共有体制の構築
  ○ 具体的な成果：
    - 大手メーカーのコーポレートサイトリニューアルにおいて、CVR前年比180%達成
    - BtoBサービスサイトの改善施策実施により、リード獲得数を前年比230%に向上
    - ディレクション品質標準化による工数削減（平均15%）と顧客満足度向上（NPS20ポイント改善）
  ○ 使用した技術・ツール：Adobe XD、Figma、Google Analytics 4、Google Data Studio、WordPress、Sitecore
  ○ 身につけたスキル：組織マネジメント、プロジェクトポートフォリオ管理、クライアント戦略コンサルティング

・株式会社Algomaticテクノロジーズ（2012年9月〜2018年3月）
  ○ 会社概要：Web制作会社、従業員50名、UI/UX設計からシステム開発まで一貫して提供
  ○ 職務内容：Webディレクター（リードディレクター）
    - 企業向けWebサービス、BtoCアプリ、ECサイトのディレクション
    - 要件定義、情報設計、ワイヤーフレーム作成、進行管理
    - デザイナー・エンジニアとのプロジェクト推進、クライアント折衝
    - アジャイル開発手法を取り入れたプロジェクト管理手法の確立
  ○ 具体的な成果：
    - 大型ECサイトリニューアルで売上前年比150%達成
    - ユーザビリティ改善施策により、アプリダウンロード数35万件達成、継続率20%向上
    - プロジェクト管理プロセス改善による納期遵守率改善（70%→95%）
  ○ 使用した技術・ツール：Adobe Photoshop、Illustrator、Sketch、Jira、Trello、HTML/CSS
  ○ 身につけたスキル：ユーザビリティテスト設計・実施、アジャイル開発管理、デジタルマーケティング戦略立案

・株式会社Algomaticクリエイティブ（2008年4月〜2012年8月）
  ○ 会社概要：広告制作会社、従業員30名、広告・Web・印刷物制作を提供
  ○ 職務内容：Webディレクター
    - コーポレートサイト、キャンペーンサイト、バナー広告制作のディレクション
    - クライアントとの打ち合わせ、要件整理、工数見積り
    - 制作スケジュール管理、品質管理
  ○ 具体的な成果：
    - キャンペーンサイト制作で応募数目標比170%達成
    - 新規クライアント獲得に貢献し、Web部門の売上30%増加に寄与
  ○ 使用した技術・ツール：Flash、Dreamweaver、Photoshop、jQuery
  ○ 身につけたスキル：Web制作基礎知識、クライアント折衝力、スケジュール管理

【受賞・表彰歴】
・2022年 第12回 ウェブ解析士協会 ベストプラクティス賞 
  「ECサイトにおけるカスタマージャーニー分析と改善施策実装」
・2019年 社内MVP賞（株式会社Algomaticデジタルマーケティング）
  大規模プロジェクトの成功と新たなディレクション手法の確立に対して
・2017年 Web制作関連技術コンテスト UXデザイン部門 優秀賞
  金融サービスアプリのUI/UX改善事例

【資格】
・ウェブ解析士マスター（2021年3月取得）
・UXデザイン検定上級（2019年11月取得）
・PMP（Project Management Professional）（2018年7月取得）
・情報処理技術者試験 応用情報技術者（2014年10月取得）
・ウェブデザイン技能検定1級（2012年6月取得）

【マネジメント経験】
・ディレクションチーム（10名）のマネジメント（2018年4月〜現在）
  ○ チームメンバーの目標設定、評価、キャリア開発支援
  ○ プロジェクト配属、リソース調整、負荷分散の最適化
  ○ 部署全体の売上・利益目標達成（前年比110%以上を4年連続達成）
  ○ メンバーの離職率低減（25%→8%）と若手ディレクターの定着率向上
・大規模Webリニューアルプロジェクト（10〜15名）のリードディレクター経験
  ○ 社内外の複数チーム（デザイン、コーディング、システム開発）の統括
  ○ 期間：3ヶ月〜1年の大型プロジェクト、10件以上
  ○ デザイナー・エンジニア・外部協力会社含むチームのマネジメント

【語学力】
・英語：ビジネスレベル
  ○ TOEIC 820点（2021年取得）
  ○ グローバル企業との打ち合わせ、提案資料作成、技術ドキュメント理解
` as const;
